import { render, staticRenderFns } from "./edit-bulk-message.vue?vue&type=template&id=56177d86&scoped=true&"
import script from "./edit-bulk-message.vue?vue&type=script&lang=js&"
export * from "./edit-bulk-message.vue?vue&type=script&lang=js&"
import style0 from "./edit-bulk-message.vue?vue&type=style&index=0&id=56177d86&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56177d86",
  null
  
)

export default component.exports